import React from "react";

function NotFound() {
    return (<div className=" items-center align-center bg-orange-500 h-[700px]">

        <div className="flex-column items-center">
            <h1>404</h1>
            <p>Page Not Found!</p>
        </div>
    </div>
    )
}

export default NotFound;